// extracted by mini-css-extract-plugin
export default {"content-wrapper":"Works_content-wrapper__4N-46","content-container":"Works_content-container__dnN3L","notfound-text":"Works_notfound-text__K6rm1"};